import { IFeature } from 'mod/featureV2/interface';
import { isPhone } from 'base/utils/client';

export const parallax1: IFeature = {
    moduleId: 'parallax1',
    title: 'parallax1',
    type: 'parallax',
    space: {
        marginTop: 0,
        marginBottom: 0,
    },
    config: {
        framesBeforeStart: 0,
        framesAfterEnd: 0,
        fadeIn: false,
        fadeOut: false,
        medias: [
            {
                type: 'canvas',
                imageDir: 'asset/width-3840/file/2ceadbe8784656022a0722577d8b67b3/1732161604982/',
                imageFrom: 1,
                imageEnd: 151,
                imageFormat: 'jpg',
                imagePositionX: isPhone ? '65%' : '50%'
            },
        ],
    },
    list: [
        {
            text: {
                title: 'Fits Anywhere',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'start',
            positonY: 'middle',
            align: isPhone ? 'center' : 'left',
            end: 50,
            animations: [false, 'fade'],
        },
    ]
};

export const parallax2: IFeature = {
    moduleId: 'parallax2',
    title: 'parallax2 - video loop false',
    type: 'parallax',
    background: {
        color: '#141414'
    },
    space: {
        marginTop: 0,
        marginBottom: 0,
    },
    config: {
        framesBeforeStart: 0,
        framesAfterEnd: 0,
        fadeIn: false,
        fadeOut: false,
        medias: [
            {
                type: 'video',
                src: 'file-asset/file/7e48bebe61f7109681414a872113c5d9.mp4',
                backup: 'file-asset/file/ef6727bd5189cc11ac06115ea0dce6d2.webm',
                stay: 100,
                loop: false,
            },
        ],
    },
    list: [
        {
            text: {
                title: 'show from the beginning, slide out',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'start',
            positonY: 'top',
            end: 5,
            animations: [false, 'slide'],
        },
        {
            text: {
                title: 'slide in, slide out',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'center',
            positonY: 'middle',
            align: 'center',
            start: 5,
            end: 25,
            animations: ['slide', 'slide']
        },
        {
            text: {
                title: 'fade in, show to the end',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'end',
            positonY: 'bottom',
            align: 'right',
            start: 25,
            animations: ['fade', false],
        },
    ]
};

export const parallax3: IFeature = {
    moduleId: 'parallax3',
    title: 'parallax3',
    type: 'parallax',
    background: {
        color: '#141414'
    },
    space: {
        marginTop: 0,
        marginBottom: 0,
    },
    config: {
        framesBeforeStart: 0,
        framesAfterEnd: 0,
        fadeIn: false,
        fadeOut: true,
        medias: [
            {
                type: 'canvas',
                imageDir: 'asset/width-1920/picture/y18_2/y18pc1-3/',
                imageFrom: 0,
                imageEnd: 74,
                extendFrames: {
                    '49': 25
                },
                imagePositionX: isPhone ? '90%' : '50%'
            },
            {
                type: 'video',
                src: 'file-asset/file/7e48bebe61f7109681414a872113c5d9.mp4',
                backup: 'file-asset/file/ef6727bd5189cc11ac06115ea0dce6d2.webm',
                stay: 100
            },
        ],
    },
    list: [
        {
            text: {
                title: 'show from the beginning, slide out',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'start',
            positonY: 'top',
            end: 20,
            animations: [false, 'slide'],
        },
        {
            text: {
                title: 'slide in, slide out',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'center',
            positonY: 'middle',
            align: 'center',
            start: 40,
            end: 70,
            animations: ['slide', 'slide']
        },
        {
            text: {
                title: 'fade in, show to the end',
                description: 'High-quality growing in a compact design. Ideal for any space.'
            },
            positonX: 'end',
            positonY: 'bottom',
            align: 'right',
            start: 90,
            animations: ['fade', false],
        },
    ]
};